import React from 'react';
import { BubbleData } from './useMapData';

interface MapBubblesProps {
  bubbleData: BubbleData[];
  onBubbleEnter: (bubble: BubbleData) => void;
  onBubbleLeave: () => void;
  onBubbleClick: (bubble: BubbleData) => void;
}

export const MapBubbles: React.FC<MapBubblesProps> = ({ 
  bubbleData, 
  onBubbleEnter, 
  onBubbleLeave,
  onBubbleClick
}) => {
  return (
    <g>
      {bubbleData.map((bubble, i) => {
        const isHealthy = bubble.isHealthy;
        const glowColor = isHealthy ? 'rgba(34, 197, 94, 0.1)' : 'rgba(239, 68, 68, 0.1)';
        const fillColor = isHealthy ? 'rgba(34, 197, 94, 0.3)' : 'rgba(239, 68, 68, 0.3)';
        const strokeColor = isHealthy ? 'rgba(34, 197, 94, 0.6)' : 'rgba(239, 68, 68, 0.6)';
        const shadowColor = isHealthy ? 'rgba(34, 197, 94, 0.2)' : 'rgba(239, 68, 68, 0.2)';
        
        return (
          <g key={`bubble-${bubble.location}-${i}`}>
            {/* Bubble glow effect */}
            <circle
              cx={bubble.x}
              cy={bubble.y}
              r={bubble.radius + 4}
              fill={glowColor}
              stroke="none"
            />
            {/* Main bubble */}
            <circle
              cx={bubble.x}
              cy={bubble.y}
              r={bubble.radius}
              fill={fillColor}
              stroke={strokeColor}
              strokeWidth={1.5}
              style={{ 
                filter: `drop-shadow(0 2px 4px ${shadowColor})`,
                cursor: 'pointer'
              }}
              className="hover-scale transition-transform duration-200"
              onMouseEnter={() => onBubbleEnter(bubble)}
              onMouseLeave={onBubbleLeave}
              onClick={(e) => {
                e.stopPropagation();
                onBubbleClick(bubble);
              }}
            >
              <title>{`${bubble.location}: ${bubble.totalSites} total sites (${bubble.activeSites} active) - ${bubble.sessions12Months.toLocaleString()} sessions - Click for details`}</title>
            </circle>
            {/* Site count text */}
            <text
              x={bubble.x}
              y={bubble.y + 2}
              textAnchor="middle"
              fontSize={Math.max(10, Math.min(16, bubble.radius * 0.4))}
              fill="white"
              fontWeight="bold"
              style={{ 
                pointerEvents: 'none',
                filter: 'drop-shadow(0 1px 1px rgba(0,0,0,0.8))'
              }}
            >
              {bubble.totalSites}
            </text>
          </g>
        );
      })}
    </g>
  );
};